import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3382">
      <Navbar data-id="element-3383" />
      <main data-id="element-3384">
        <ConsularAffairs data-id="element-3385" />
      </main>
      <Footer data-id="element-3386" />
      <FeedbackPopup data-id="element-3387" />
    </div>;
}